jQuery(document).ready(function ($) {
  var POLL_INTERVAL_MS = 30000;

  var FINISHED_STATUSES = [
    'finished',
    'finished ap',
    'finished et',
    'not started',
    'cancelled',
    'postponed',
    'abandoned',
    'awarded',
  ];

  function normalizeStatus(status) {
    return String(status || '').trim().toLowerCase();
  }

  function isLiveStatus(status) {
    var normalized = normalizeStatus(status);
    return normalized !== '' && FINISHED_STATUSES.indexOf(normalized) === -1;
  }

  var STATUS_LABELS = {
    'finished': 'Avsluttet',
    'finished ap': 'Avsluttet etter straffespark',
    'finished et': 'Avsluttet etter ekstra tid',
    'not started': 'Ikke startet',
    'cancelled': 'Avlyst',
    'postponed': 'Utsatt',
    'abandoned': 'Oppgitt',
    'awarded': 'Tildelt',
    'half time': 'Halvtid',
    'halftime': 'Halvtid',
    'ht': 'Halvtid',
    '1st half': '1. omgang',
    '2nd half': '2. omgang',
  };

  function formatStatusLabel(status) {
    var normalized = normalizeStatus(status);

    if (!normalized) {
      return '';
    }

    return STATUS_LABELS[normalized] || status;
  }

  function formatMatchTime(time) {
    var value = String(time || '').trim();

    if (value === '') {
      return '';
    }

    if (/^\d+$/.test(value)) {
      return value + "'";
    }

    return value;
  }

  function readMatchClock($pill) {
    if (!$pill || !$pill.length) {
      return null;
    }

    return {
      label: $.trim($pill.text()),
      phase: $pill.attr('data-clock-phase') || '',
      is_running: $pill.attr('data-clock-running') === '1',
      tick_from: parseInt($pill.attr('data-clock-tick-from') || '0', 10) || 0,
      base_minute: parseInt($pill.attr('data-clock-base-minute') || '0', 10) || 0,
      server_now: parseInt($pill.attr('data-clock-server-now') || '0', 10) || 0,
    };
  }

  function computeClockLabel(clock) {
    if (!clock) {
      return '';
    }

    if (!clock.is_running) {
      return clock.label || '';
    }

    if (!clock.tick_from) {
      return formatMatchTime(clock.label);
    }

    var elapsedSeconds = Math.max(0, Math.floor(Date.now() / 1000) - clock.tick_from);
    var minute = Math.max(1, (clock.base_minute || 0) + Math.floor(elapsedSeconds / 60));

    return minute + "'";
  }

  function applyClockAttributes($pill, clock) {
    if (!$pill.length || !clock) {
      return;
    }

    $pill.attr('data-clock-phase', clock.phase || '');
    $pill.attr('data-clock-running', clock.is_running ? '1' : '0');
    $pill.attr('data-clock-tick-from', String(clock.tick_from || 0));
    $pill.attr('data-clock-base-minute', String(clock.base_minute || 0));
    $pill.attr('data-clock-server-now', String(clock.server_now || 0));

    if (clock.phase) {
      $pill
        .removeClass(function (index, className) {
          return (className.match(/live-signal-widget__time-pill--\S+/g) || [])
            .filter(function (item) {
              return item !== 'live-signal-widget__time-pill--empty';
            })
            .join(' ');
        })
        .addClass('live-signal-widget__time-pill--' + clock.phase);
    }
  }

  function updateMatchClock($root, clock) {
    var $pill = $root.find('[data-live-signal-match-time]');

    if (!$pill.length) {
      return;
    }

    if (!clock) {
      clock = readMatchClock($pill);
    }

    applyClockAttributes($pill, clock);

    var label = computeClockLabel(clock);

    if (label === '') {
      $pill.text('').addClass('live-signal-widget__time-pill--empty').attr('aria-hidden', 'true');
      return;
    }

    $pill.removeClass('live-signal-widget__time-pill--empty').removeAttr('aria-hidden');
    updateTextIfChanged($pill, label);
  }

  function startMatchClockTicker($root) {
    if ($root.attr('data-clock-interval-id')) {
      return;
    }

    var intervalId = window.setInterval(function () {
      var $pill = $root.find('[data-live-signal-match-time]');
      var clock = readMatchClock($pill);

      if (!clock || !clock.is_running || !clock.tick_from) {
        return;
      }

      updateMatchClock($root, clock);
    }, 1000);

    $root.attr('data-clock-interval-id', String(intervalId));
  }

  function stopMatchClockTicker($root) {
    var intervalId = parseInt($root.attr('data-clock-interval-id') || '0', 10);

    if (intervalId) {
      window.clearInterval(intervalId);
      $root.removeAttr('data-clock-interval-id');
    }
  }

  function formatStatValue(value) {
    if (value === null || value === undefined || value === '') {
      return '–';
    }

    if (!isNaN(value)) {
      return String(parseInt(value, 10));
    }

    return String(value);
  }

  function normalizePossession(value) {
    if (value === null || value === undefined || value === '' || isNaN(value)) {
      return null;
    }

    var pct = parseFloat(value);

    if (pct <= 1) {
      pct *= 100;
    }

    return Math.max(0, Math.min(100, Math.round(pct)));
  }

  function resolvePossession(homeStats, awayStats) {
    var homePoss = normalizePossession(homeStats.possession);
    var awayPoss = normalizePossession(awayStats.possession);

    if (homePoss !== null && awayPoss === null) {
      awayPoss = Math.max(0, 100 - homePoss);
    } else if (awayPoss !== null && homePoss === null) {
      homePoss = Math.max(0, 100 - awayPoss);
    }

    if (homePoss === null || awayPoss === null) {
      return null;
    }

    return {
      home: homePoss,
      away: awayPoss,
    };
  }

  function parseScores(matchData) {
    var stats = matchData && matchData.goals_and_stats ? matchData.goals_and_stats : {};
    var board = matchData && matchData.scoreboard ? matchData.scoreboard : {};
    var context = matchData && matchData.match_context ? matchData.match_context : {};
    var home = stats.home || {};
    var away = stats.away || {};

    var homeScore = board.home_score != null ? board.home_score : home.goal;
    var awayScore = board.away_score != null ? board.away_score : away.goal;

    return {
      homeTeam: board.home_team || home.team || '',
      awayTeam: board.away_team || away.team || '',
      homeFlag: board.home_flag || '',
      awayFlag: board.away_flag || '',
      homeScore: parseInt(homeScore, 10) || 0,
      awayScore: parseInt(awayScore, 10) || 0,
      status: context.status || board.match_status || '',
      matchTime: context.time || '',
      matchClock: context.clock || null,
      homeStats: home,
      awayStats: away,
    };
  }

  function getWinningTeam(scores) {
    if (scores.homeScore > scores.awayScore) {
      return scores.homeTeam;
    }
    if (scores.awayScore > scores.homeScore) {
      return scores.awayTeam;
    }
    return '';
  }

  function formatOperatorCta(template, scores, operatorName) {
    var winner = getWinningTeam(scores);
    var replacements = {
      '{operator}': operatorName || '',
      '{home_team}': scores.homeTeam || '',
      '{away_team}': scores.awayTeam || '',
      '{team}': winner || scores.homeTeam || '',
      '{home_score}': String(scores.homeScore),
      '{away_score}': String(scores.awayScore),
    };

    return String(template || 'SPILL HOS {operator}').replace(
      /\{operator\}|\{home_team\}|\{away_team\}|\{team\}|\{home_score\}|\{away_score\}/g,
      function (token) {
        return replacements[token] || '';
      }
    );
  }

  function updateTextIfChanged($el, nextText) {
    if (!$el.length) {
      return false;
    }

    var current = $.trim($el.text());
    if (current === nextText) {
      return false;
    }

    $el.text(nextText);
    return true;
  }

  function updateMatchTime($root, matchTime, matchClock) {
    if (matchClock) {
      updateMatchClock($root, matchClock);
      return;
    }

    updateMatchClock($root, {
      label: formatMatchTime(matchTime),
      phase: 'unknown',
      is_running: false,
      tick_from: 0,
      base_minute: 0,
      server_now: 0,
    });
  }

  function updatePossession($root, homeStats, awayStats) {
    var $section = $root.find('[data-live-signal-possession]');
    var $statsSection = $root.find('[data-live-signal-stats]');
    var possession = resolvePossession(homeStats, awayStats);

    if (!$section.length) {
      return;
    }

    if (!possession) {
      $statsSection.addClass('live-signal-widget__stats--no-possession');
      $section.css('--ls-home-poss', '50').css('--ls-away-poss', '50');
      updateTextIfChanged($root.find('[data-live-signal-home-poss]'), '–');
      updateTextIfChanged($root.find('[data-live-signal-away-poss]'), '–');
      return;
    }

    $statsSection.removeClass('live-signal-widget__stats--no-possession');
    $section.css('--ls-home-poss', String(possession.home)).css('--ls-away-poss', String(possession.away));
    updateTextIfChanged($root.find('[data-live-signal-home-poss]'), String(possession.home) + '%');
    updateTextIfChanged($root.find('[data-live-signal-away-poss]'), String(possession.away) + '%');
  }

  function escapeHtml(value) {
    return $('<div>').text(value == null ? '' : String(value)).html();
  }

  function renderIncidentTimeline(items) {
    if (!items || !items.length) {
      return '';
    }

    return items
      .map(function (item) {
        var category = item.category || 'other';
        var side = item.side || 'neutral';
        var timeLabel = item.time_label || '';
        var label = item.label || '';
        var team = item.team || '';
        var timeHtml = timeLabel
          ? '<span class="live-signal-widget__incident-time">' + escapeHtml(timeLabel) + '</span>'
          : '';
        var teamHtml = team
          ? '<span class="live-signal-widget__incident-team">' + escapeHtml(team) + '</span>'
          : '';

        return (
          '<li class="live-signal-widget__incident live-signal-widget__incident--' +
          escapeHtml(category) +
          ' live-signal-widget__incident--' +
          escapeHtml(side) +
          '" data-incident-category="' +
          escapeHtml(category) +
          '" data-incident-side="' +
          escapeHtml(side) +
          '">' +
          timeHtml +
          '<span class="live-signal-widget__incident-body">' +
          '<span class="live-signal-widget__incident-label">' +
          escapeHtml(label) +
          '</span>' +
          teamHtml +
          '</span></li>'
        );
      })
      .join('');
  }

  function updateIncidents($root, matchData) {
    var items = matchData && matchData.incident_timeline ? matchData.incident_timeline : [];
    var $list = $root.find('[data-live-signal-incident-list]');

    if (!$list.length) {
      return;
    }

    $list.html(items.length ? renderIncidentTimeline(items) : '');
  }

  function updateIncidentsToggleLabel($btn, expanded) {
    var showLabel = $btn.attr('data-label-show') || 'Vis kamphendelser';
    var hideLabel = $btn.attr('data-label-hide') || 'Skjul kamphendelser';

    $btn.text(expanded ? hideLabel : showLabel);
  }

  function setIncidentsListExpanded($root, expanded) {
    var $list = $root.find('[data-live-signal-incident-list]');
    var $btn = $root.find('[data-live-signal-incidents-toggle]');

    if (!$list.length || !$btn.length) {
      return;
    }

    $btn.attr('aria-expanded', expanded ? 'true' : 'false');
    updateIncidentsToggleLabel($btn, expanded);

    if (expanded) {
      $list.removeAttr('hidden');
      $root.addClass('live-signal-widget--incidents-open');
    } else {
      $list.attr('hidden', 'hidden');
      $root.removeClass('live-signal-widget--incidents-open');
    }
  }

  function initIncidentsToggle($root) {
    $root.on('click', '[data-live-signal-incidents-toggle]', function () {
      var expanded = $(this).attr('aria-expanded') === 'true';

      setIncidentsListExpanded($root, !expanded);
    });
  }

  function updateStats($root, homeStats, awayStats) {
    var statKeys = [
      'shots_on_target',
      'shots_off_target',
      'corners',
      'dangerous_attacks',
      'fouls',
      'offsides',
      'yellow_cards',
      'red_cards',
    ];

    statKeys.forEach(function (key) {
      updateTextIfChanged(
        $root.find('[data-live-signal-stat-home="' + key + '"]'),
        formatStatValue(homeStats[key])
      );
      updateTextIfChanged(
        $root.find('[data-live-signal-stat-away="' + key + '"]'),
        formatStatValue(awayStats[key])
      );
    });

    updatePossession($root, homeStats, awayStats);
  }

  function updateTeamFlag($img, url) {
    if (!$img.length) {
      return;
    }

    url = String(url || '').trim();

    if (!url) {
      $img.attr('src', '').attr('hidden', 'hidden');
      return;
    }

    if ($img.attr('src') !== url) {
      $img.attr('src', url);
    }

    $img.removeAttr('hidden');
  }

  function updateLeadingStates($root, scores) {
    var homeLeading = scores.homeScore > scores.awayScore;
    var awayLeading = scores.awayScore > scores.homeScore;

    $root.find('[data-live-signal-home-score]').toggleClass('live-signal-widget__score--leading', homeLeading);
    $root.find('[data-live-signal-away-score]').toggleClass('live-signal-widget__score--leading', awayLeading);
    $root.find('[data-live-signal-home-team]').toggleClass('live-signal-widget__team-name--leading', homeLeading);
    $root.find('[data-live-signal-away-team]').toggleClass('live-signal-widget__team-name--leading', awayLeading);
  }

  function updateOperatorCtas($root, scores) {
    var template = $root.attr('data-cta-template') || 'SPILL HOS {operator}';

    $root.find('[data-live-signal-operator-cta]').each(function () {
      var $ctaMain = $(this);
      var $cta = $ctaMain.closest('[data-operator-name]');
      var operatorName = $cta.attr('data-operator-name') || '';

      if ($cta.hasClass('live-signal-widget__cta--disabled')) {
        return;
      }

      updateTextIfChanged($ctaMain, formatOperatorCta(template, scores, operatorName));
    });
  }

  function updateAiText($root, nextText) {
    var $section = $root.find('[data-live-signal-ai]');
    var $text = $root.find('[data-live-signal-ai-text]');

    if (!$text.length) {
      return;
    }

    nextText = $.trim(nextText || '');
    var current = $.trim($text.text());

    if (nextText === current) {
      $section.toggleClass('live-signal-widget__ai--empty', nextText === '');
      return;
    }

    if (!nextText) {
      $section.addClass('live-signal-widget__ai--empty');
      $text.text('');
      return;
    }

    $section.removeClass('live-signal-widget__ai--empty');

    $text.addClass('is-fading-out');

    window.setTimeout(function () {
      $text.text(nextText);
      $text.removeClass('is-fading-out').addClass('is-fading-in');

      window.setTimeout(function () {
        $text.removeClass('is-fading-in');
      }, 280);
    }, 220);
  }

  function applyPayload($root, payload) {
    if (!payload || !payload.match_data) {
      return;
    }

    var matchData = payload.match_data;
    var scores = parseScores(matchData);
    var live = isLiveStatus(scores.status);

    $root.toggleClass('live-signal-widget--live', live);
    updateTextIfChanged($root.find('[data-live-signal-status]'), formatStatusLabel(scores.status));
    updateMatchTime($root, scores.matchTime, scores.matchClock);
    updateTextIfChanged($root.find('[data-live-signal-home-team]'), scores.homeTeam);
    updateTextIfChanged($root.find('[data-live-signal-away-team]'), scores.awayTeam);
    updateTeamFlag($root.find('[data-live-signal-home-flag]'), scores.homeFlag);
    updateTeamFlag($root.find('[data-live-signal-away-flag]'), scores.awayFlag);
    updateTextIfChanged($root.find('[data-live-signal-home-score]'), String(scores.homeScore));
    updateTextIfChanged($root.find('[data-live-signal-away-score]'), String(scores.awayScore));
    updateLeadingStates($root, scores);
    updateStats($root, scores.homeStats, scores.awayStats);
    updateIncidents($root, matchData);
    updateOperatorCtas($root, scores);
    updateAiText($root, payload.ai_text || '');

    if ($root.hasClass('live-signal-widget--loading')) {
      $root.removeClass('live-signal-widget--loading');
    }

    if (!live) {
      $root.attr('data-polling-stopped', '1');
      stopMatchClockTicker($root);
    } else {
      startMatchClockTicker($root);
    }
  }

  function fetchLiveSignal($root) {
    if ($root.attr('data-polling-stopped') === '1') {
      return;
    }

    var eventId = $root.attr('data-event-id');
    var ajaxUrl = $root.attr('data-ajax-url');
    var action = $root.attr('data-ajax-action') || 'get_live_signal';

    if (!eventId || !ajaxUrl) {
      return;
    }

    $.ajax({
      url: ajaxUrl,
      method: 'GET',
      dataType: 'json',
      cache: false,
      data: {
        action: action,
        event_id: eventId,
      },
    })
      .done(function (payload) {
        applyPayload($root, payload);
      })
      .fail(function () {
        // Silent fail — keep current DOM state to avoid flicker.
      });
  }

  function initWidget($root) {
    if ($root.attr('data-live-signal-initialized') === '1') {
      return;
    }

    $root.attr('data-live-signal-initialized', '1');

    initIncidentsToggle($root);
    startMatchClockTicker($root);
    fetchLiveSignal($root);

    window.setInterval(function () {
      fetchLiveSignal($root);
    }, POLL_INTERVAL_MS);
  }

  $('[data-live-signal-root]').each(function () {
    initWidget($(this));
  });
});
